import "./innerheader.scss";
import ChevronIcon from "../../../svg-icons/chevron-icon";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { API_BASE_URL } from "configs/AppConfig";
import { useSelector } from "react-redux";
// import { useReactToPrint } from "react-to-print";

function InnerHeader({breadcrumb, title, route = '', profileFile = false}) {

  const pdfImage = process.env.PUBLIC_URL + "/image/pdf.png";
  const dir = useSelector(({ theme }) => theme.direction);

  // const elementPdf = useRef(null);
  // const generateToPDF = useReactToPrint({
  //   documentTitle: <FormattedMessage id="profile" />,
  //   content: () => elementPdf.current,
  // })

  const listBread = breadcrumb.map((ele, i) => {
    return (
      <li key={i}>
        <Link to={`${i === 0 ? route : ''}`} className={ele.clickClass ? "cant_click" : ""}>
          <ChevronIcon width={10} height={10} />
          <span className={`${i === 1 ? "fw-bold" : null}`}>{ele.title}</span>
        </Link>
      </li>
    );
  });
  return (
    <div className="inner-header">
      <div className="container">
        <div className="row d-flex align-items-end gx-0 gy-3 gy-md-0">
          <div className="col-md-6">
            <div className="breadcrumb">
              <Link to={"/"}>
                <span>
                  <i className="fas fa-home"></i>
                </span>
              </Link>
              <ul>{listBread}</ul>
            </div>

            <div className="inner-title">
              <h4> {title}</h4>
            </div>
          </div>
          {profileFile && <div className="col-md-6">
            <a href={`${API_BASE_URL}/News/Pdf/0f0f0f01-8f2f-4bea-b657-f2584196eb29.pdf`} target="_blank" rel="noreferrer" download className={`main-btn gap-2 ${dir === 'rtl' ? 'me-auto' : 'ms-auto'}`} style={{width: 'fit-content'}}>
              <span style={{fontWeight: '500'}}>
                <FormattedMessage id="download-profile" />
              </span>
              <img src={pdfImage} style={{width: '25px' , cursor: 'pointer' , borderRadius: '6px'}} alt="pdf-image" />
            </a>
          </div>}
        </div>
      </div>
    </div>
  );
}

export default InnerHeader;
